module.exports = __webpack_public_path__ + "media/images/flags/MO-3962cc04dd94c1c977acad4981ae3059.svg";